import React, { useEffect } from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import MainInput from "../Components/MainInput";
import SendNotificationsHooks from "../hooks/SendNotificationsHooks";
import UploadImage from "../Components/UploadImage";
import { Select, MenuItem, FormControl, InputLabel, Switch, FormControlLabel } from "@mui/material";

const SendNotifications = () => {
  const {
    title,
    NavItems,
    setTitle,
    body,
    setBody,
    allUsers,
    setAllUsers,
    users,
    global,
    selectedUsers,
    setSelectedUsers,
    handleImageUpload,
    handleSubmit,
    btnLoading,
    sellers,
    setGlobal,
    setSelectedSellers,
    selectedSellers,
    setAllSellers,
    allSellers
  } = SendNotificationsHooks();



  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center">
          <PagesNav links={NavItems} />
        </div>

        <form
          className="d-flex flex-column justify-content-between h-100"
          onSubmit={handleSubmit}
        >
          <div className="row g-3">
            <div className="col-md-6">
              <MainInput
                label="Title*"
                forceWidht
                placeholder="Enter Title..."
                forceWidth
                type="text"
                value={title}
                required
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <MainInput
                label="Body"
                forceWidht
                placeholder="Enter Body..."
                forceWidth
                type="text"
                value={body}
                onChange={(e) => setBody(e.target.value)}
              />
            </div>

              <div className="col-md-4 d-flex align-items-center">
                <FormControlLabel
                  control={
                    <Switch
                      checked={global}
                      onChange={() => setGlobal(!global)}
                      color="primary"
                    />
                  }
                  label="Send Global"
                />
              </div>
              {!global && <>
                <div className="col-md-4 d-flex align-items-center">
                <FormControlLabel
                  control={
                    <Switch
                      checked={allUsers}
                      onChange={() => setAllUsers(!allUsers)}
                      color="primary"
                    />
                  }
                  label="Send to All Customers"
                />
              </div>
              <div className="col-md-4 d-flex align-items-center">
                <FormControlLabel
                  control={
                    <Switch
                      checked={allSellers}
                      onChange={() => setAllSellers(!allSellers)}
                      color="primary"
                    />
                  }
                  label="Send to All sellers"
                />
              </div>
              </>}
              

            {!allUsers && (
              <div className="d-flex justify-content-center">
              <div className="col-md-12 ">
              <FormControl fullWidth className="w-100">
              <InputLabel>Select Customers</InputLabel>
              <Select
                multiple
                value={selectedUsers}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedUsers(
                    typeof value === "string" ? value.split(",") : value
                  );
                }}
                renderValue={(selected) =>  
                  selected
                    .map((id) => users.find((user) => user._id === id)?.name)
                    .join(", ")
                }
              >
                {users.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

              </div>
              </div>
            )}


            {!allSellers && (
              <div className="d-flex justify-content-center">
              <div className="col-md-12 ">
              <FormControl fullWidth className="w-100">
              <InputLabel>Select Merchants</InputLabel>
              <Select
                multiple
                value={selectedSellers}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedSellers(
                    typeof value === "string" ? value.split(",") : value
                  );
                }}
                renderValue={(selected) =>  
                  
                  selected
                    .map((id) => sellers.find((seller) => seller._id === id)?.name)
                    .join(", ")
                }
              >
                {sellers.map((seller) => (
                  <MenuItem key={seller._id} value={seller._id}>
                    {seller.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

              </div>
              </div>
            )}

            <div className="col-md-12">
              <UploadImage onChange={handleImageUpload} forceWidht/>
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-center pb-3 mt-4">
                 <button
                type="submit"
                disabled={btnLoading}
                className="btn bg-white text-main shadow-lg px-5 py-2 fw-bold"
              >
                {btnLoading ? (
                  <i className="fa-solid fa-fan fa-spin fa-spin-reverse"></i>
                ) : (
                  "Submit"
                )}
              </button>
          </div>
        </form>
      </MainContainer>
    </>
  );
};

export default SendNotifications;
